import {
  Root as ProgressRootPrimitive,
  Indicator as ProgressIndicatorPrimitive,
} from "@radix-ui/react-progress";
import type React from "react";

import { cn } from "@/lib/utils";

function Progress({
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressRootPrimitive>) {
  return (
    <ProgressRootPrimitive
      className={cn("relative h-2 w-full overflow-hidden rounded-full bg-primary/20", className)}
      data-slot="progress"
      {...props}
    >
      <ProgressIndicatorPrimitive
        className="h-full w-full flex-1 bg-primary transition-all"
        data-slot="progress-indicator"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressRootPrimitive>
  );
}

export { Progress };
